import { generateTimeLabels } from 'common/utils/time';

export const times = generateTimeLabels('00:05', 5, 'm');

export const MINUTES_IN_HOUR = 60;
export const MINUTES_IN_DAY = 1440;
export const MINUTES_IN_WEEK = 10080;
